<div class="edition-marketing-container">
  <section class="edition-card-container" *ngFor="let priceCard of priceCardData">
    <mat-card appearance="outlined" class="edition-marketing-card">
      <mat-card-content>
        <div class="edition-title" *ngIf="priceCard.name">
          {{ priceCard.name }}
        </div>

        <div class="price-display-box">
          <ng-container>
            <billing-ui-price-display
              [appPrice]="appPrice"
              [align]="'start'"
              [currencyCode]="currency"
              [size]="'large'"
              [editionId]="priceCard.editionId || ''"
              [form]="'verbose'"
            ></billing-ui-price-display>
          </ng-container>
        </div>

        <div class="add-to-cart-button">
          <button
            *ngIf="isEditionActionUsed"
            mat-flat-button
            color="primary"
            (click)="
              editionActionClick.emit({
                appId: priceCard.appId,
                editionId: priceCard.editionId
              })
            "
          >
            <span>{{ 'FRONTEND.STORE.ADD_TO_CART' | translate }}</span>
          </button>
        </div>

        <ng-container *ngIf="marketingType === 1; else endUser">
          <ng-container *ngIf="priceCard.resellerMarketing">
            <div>
              <div *ngIf="priceCard.resellerMarketing.description" class="marketing-description">
                {{ priceCard.resellerMarketing.description }}
              </div>
              <ul *ngIf="priceCard.resellerMarketing.keySellingPoints" class="marketing-ks">
                <li *ngFor="let ks of priceCard.resellerMarketing.keySellingPoints">
                  <p>{{ ks }}</p>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #endUser>
          <ng-container *ngIf="priceCard.endUserMarketing">
            <div>
              <div *ngIf="priceCard.endUserMarketing.description" class="marketing-description">
                {{ priceCard.endUserMarketing.description }}
              </div>
              <ul *ngIf="priceCard.endUserMarketing.keySellingPoints" class="marketing-ks">
                <li *ngFor="let ks of priceCard.endUserMarketing.keySellingPoints">
                  <p>{{ ks }}</p>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </section>
</div>
